import React, { useEffect, useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { AiOutlineFile, AiOutlineCloudDownload, AiOutlineDelete, AiOutlineEye, AiOutlineEyeInvisible, AiOutlineEdit } from 'react-icons/ai';
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService';
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { toDataSourceRequestString, translateDataSourceResultGroups, filterBy } from '@progress/kendo-data-query';
import { Pager } from "@progress/kendo-react-data-tools";

const SecurityObjectName = 'Website.NewsLetter';

const DashboardNewsLetter = (props) => {

    const [dataState, setDataState] = useState({
        skip: 0, take: 10
    });
    const [total, setTotal] = useState(0);

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, setValue, formState: { errors },
        clearErrors } = useForm({});
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');
    const [newsLetter, setNewsLetter] = useState([]);

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (data.file[0] !== undefined && data.file[0].name !== null) {
            await HttpHelper.post("NewsLetter/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                }
            }).then(async (response) => {
                if (response.status === 200) {
                    data.FileId = response.data[0].fileId;
                    delete data.file;
                    NewsLetterAdd(data, data.FileId);
                } else {
                    console.log('error while uploading the image');
                }
                getNewsLetterList();
            }).catch((error) => {
                console.log(error);
            })
        }
    };
    const NewsLetterAdd = async (data, el) => {
        if (data.OpenToPublic == 'true') {
            data.OpenToPublic = true
        } else {
            data.OpenToPublic = false
        }

        await HttpHelper.post("NewsLetter", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            if (response.status === 200) {
            } else {
                console.log('error while uploading the image');
            }
            props.showToast('success', 'NewsLetter Added Succesfully');
            clearAllFields();
            getNewsLetterList();
        }).catch((error) => {
            DeleteUploadedFile(data.FileId)
            console.log(error);
        })
    }
    const NewsLetterUpdate = async (data) => {
        data.openToPublic = !data.openToPublic
        await HttpHelper.put("NewsLetter", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            if (response.status === 200) {
            } else {
                console.log('error while uploading the image');
            }
            props.showToast('success', 'NewsLetter Updated Succesfully');
            clearAllFields();
            getNewsLetterList();
        }).catch((error) => {
            DeleteUploadedFile(data.FileId)
            console.log(error);
        })
    }
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("NewsLetter/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const deleteNewsLetterById = async (newsletterId) => {
        if (newsletterId === null || newsletterId === undefined) {
            return false;
        }
        swal("Are you sure, you want to delete this menu?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("Newsletter/" + newsletterId).then((response) => {
                        if (response.status === 200) {
                        }
                        getNewsLetterList();
                    }).catch((error) => {
                        console.log(error);
                    })


                }
            });
    }

    const accordianStatusHandle = (e, elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    const getNewsLetterList = async () => {
        setLoaderApi(true);
        const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state.
        await HttpHelper.get("NewsLetter?" + queryStr).then((res) => {
            const arraySorted = res.data.data.sort(function (a, b) {
                return a.year - b.year;
            });
            setNewsLetter((prev) => {
                return [prev, ...arraySorted]
            });
            getAllPermission();
            setLoaderApi(false);
            setTotal(res.data.total);
        }).catch((error) => {
            console.log(error);
        })
    }

    const handlePageChange = (event) => {
        setDataState({
            skip: event.skip,
            take: event.take,
        });
    };

    const clearAllFields = () => {
        setValue('NewsLetterName', '');
        setValue('Year', '');
        setValue('file', '');
    }

    useEffect(() => {
        getNewsLetterList();
    }, [dataState])

    return (<DashboardWrapper>
        <ToastContainer />
        <div className="DashboardWrapperChild">
            <Sidebar />
            <div className="contentWrapper">
                <HeaderDashboard title="News Letter" />
                <div className="container-fluid mt-80 p-0">
                    <div className="row">
                        {
                            hasAddPermissionUser == true ? <div className="col-auto">
                                <button onClick={() => {
                                    setPopupAddEdit(true);
                                }} className="btn btnSave">Add News Letter</button>
                            </div> : ''
                        }
                        <div className="col-md-12 mb-2">
                        </div>
                        {
                            hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2">
                                <div className="cardBox ">
                                    <h4>News letter</h4>
                                    <div className="row tableMenuEdit">
                                        <div className="accordion" id="Newsletter">
                                            <div className="cardBox  cardTableGridNewDesign">
                                                <div className="NewsletterWrapper">
                                                    {newsLetter && newsLetter.map((e, i) => {
                                                        if (e.year && e.newsLetterName) {
                                                            return <>
                                                                {
                                                                    newsLetter[i] != 0 && newsLetter[i - 1].year == e.year ? <>
                                                                        <div className="newsLetterDetailsWrapper">
                                                                            <div className="nameLetter">
                                                                                {e.newsLetterName}
                                                                            </div>
                                                                            {
                                                                                hasReadPermissionUser || hasDeletePermissionUser || hasEditPermissionUser ? <div className="fileLetter">
                                                                                    {hasReadPermissionUser == true ? <a href={e.file && e.file.fileUrl}>
                                                                                        <AiOutlineCloudDownload />
                                                                                    </a> : ''}
                                                                                    {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { deleteNewsLetterById(e.newsletterId) }} /> : ''}
                                                                                    {hasEditPermissionUser == true ? <div className={`fileLetterText ${e.openToPublic == true ? 'active' : ''}`} onClick={() => { NewsLetterUpdate(e) }}>
                                                                                        {e.openToPublic == true ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}   {e.openToPublic == true ? 'Show' : 'Hide'} to public</div> : ''}
                                                                                </div> : ''
                                                                            }
                                                                        </div>
                                                                    </>
                                                                        :
                                                                        <>
                                                                            <div className="yearLetter">
                                                                                {e.year} Issues
                                                                            </div>
                                                                            <div className="newsLetterDetailsWrapper">
                                                                                <div className="nameLetter">
                                                                                    {e.newsLetterName}
                                                                                </div>
                                                                                {
                                                                                    hasReadPermissionUser || hasDeletePermissionUser || hasEditPermissionUser ? <div className="fileLetter">
                                                                                        {hasReadPermissionUser == true ? <a href={e.file && e.file.fileUrl}><AiOutlineCloudDownload /></a> : ''}
                                                                                        {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { deleteNewsLetterById(e.newsletterId) }} /> : ''}
                                                                                        {hasEditPermissionUser == true ? <AiOutlineEdit onClick={() => { deleteNewsLetterById(e.newsletterId) }} /> : ''}
                                                                                        {hasEditPermissionUser == true ? <div className={`fileLetterText ${e.openToPublic == true ? 'active' : ''}`} onClick={() => { NewsLetterUpdate(e) }}>
                                                                                            {e.openToPublic == true ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}   {e.openToPublic == true ? 'Show' : 'Hide'} to public</div> : ''}
                                                                                    </div> : ''
                                                                                }
                                                                            </div>
                                                                        </>}
                                                            </>
                                                        }
                                                    })}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                                loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                        }
                        <Pager
                            style={{ "margin-top": "20px" }}
                            buttonCount={20}
                            previousNext={true}
                            info={true}
                            total={total}
                            skip={dataState.skip}
                            take={dataState.take}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </div>

        {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
            <div className="popupEditAndAddForm">
                <div className="popupEditAndAddFormCloseButton" onClick={() => {
                    setPopupAddEdit(false);
                }} >
                    <RxCross2 />
                </div>

                {loaderApi == true ? <div className="loaderApi">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                </path>
                            </g>
                        </g>
                    </svg>
                </div> : <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="cardBox cardTableWrapperDashboard">
                        <h4>Add Newletter</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <label>NewsLetter Name : <span class="requiredAstric"> *</span></label>
                                <input type="text"  {...register("NewsLetterName", { required: true })} className="border mb-2" placeholder="Newsletter title" aria-invalid={errors.Heading ? "true" : "false"} />
                                {errors.NewsLetterName?.type === 'required' && <p className="text-danger" role="alert">Title is required</p>}
                            </div>
                            <div className="col-md-6">
                                <label>File : <span class="requiredAstric"> *</span></label>
                                <input type="file"  {...register('file', { required: true })} className="border mb-2 w-100 is-invalid" />
                                {errors.file?.type === 'required' && <p className="text-danger" role="alert">File is required</p>}
                            </div>
                            <div className="col-md-6">
                                <label>Show to Public : <span class="requiredAstric"> *</span></label>
                                <select className="border mb-2 selectboxEdit" {...register("OpenToPublic", { required: true })}>
                                    <option value="">Select</option>
                                    <option key={true} value={true}>Yes</option>
                                    <option key={false} value={false}>No</option>
                                </select>
                                {errors.Year?.type === 'required' && <p className="text-danger" role="alert">Year is required</p>}
                            </div>
                            <div className="col-md-6">
                                <label>Select Year : <span class="requiredAstric"> *</span></label>
                                <select className="border mb-2 selectboxEdit" {...register("Year", { required: true })}>
                                    <option value="">Select Year</option>
                                    <option key={2010} value={2010}>2010</option>
                                    <option key={2011} value={2011}>2011</option>
                                    <option key={2012} value={2012}>2012</option>
                                    <option key={2013} value={2013}>2013</option>
                                    <option key={2014} value={2014}>2014</option>
                                    <option key={2015} value={2015}>2015</option>
                                    <option key={2016} value={2016}>2016</option>
                                    <option key={2017} value={2017}>2017</option>
                                    <option key={2018} value={2018}>2018</option>
                                    <option key={2019} value={2019}>2019</option>
                                    <option key={2020} value={2020}>2020</option>
                                    <option key={2021} value={2021}>2021</option>
                                    <option key={2022} value={2022}>2022</option>
                                    <option key={2023} value={2023} selected="selected">2024</option>
                                    <option key={2024} value={2024}>2024</option>
                                    <option key={2025} value={2025}>2025</option>
                                    <option key={2026} value={2026}>2026</option>
                                    <option key={2027} value={2027}>2027</option>
                                    <option key={2028} value={2028}>2028</option>
                                    <option key={2029} value={2029}>2029</option>
                                    <option key={2030} value={2030}>2030</option>
                                </select>
                                {errors.Year?.type === 'required' && <p className="text-danger" role="alert">Year is required</p>}
                            </div>
                            <div className="col-md-12 d-flex justify-content-end mt-3">
                                <div>
                                    <button className="btn btnSave mt-2">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>}

            </div>
        </div> : ''}


    </DashboardWrapper>
    )
}

export default DashboardNewsLetter;